// Dark Theme Component Overrides
// Modern glassmorphism styling for all MUI components

const components = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        backgroundColor: '#0F172A',
        color: '#F1F5F9',
      },
    },
  },

  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        padding: '10px 20px',
        fontWeight: 600,
        boxShadow: 'none',
        transition: 'all 0.2s ease-in-out',
        textTransform: 'none',
        '&:hover': {
          boxShadow: '0px 4px 12px rgba(18, 180, 161, 0.3)',
          transform: 'translateY(-1px)',
        },
      },
      containedPrimary: {
        background: 'linear-gradient(135deg, #139979 0%, #12B4A1 50%, #0596B3 100%)',
        color: '#FFFFFF',
        '&:hover': {
          background: 'linear-gradient(135deg, #107D63 0%, #0E9185 50%, #047799 100%)',
        },
      },
      outlinedPrimary: {
        borderColor: 'rgba(18, 180, 161, 0.5)',
        color: '#12B4A1',
        '&:hover': {
          borderColor: '#12B4A1',
          backgroundColor: 'rgba(18, 180, 161, 0.08)',
        },
      },
      outlinedSecondary: {
        borderColor: 'rgba(255, 255, 255, 0.3)',
        color: '#94A3B8',
        '&:hover': {
          borderColor: 'rgba(255, 255, 255, 0.5)',
          backgroundColor: 'rgba(255, 255, 255, 0.08)',
        },
      },
      textPrimary: {
        color: '#12B4A1',
        '&:hover': {
          backgroundColor: 'rgba(18, 180, 161, 0.08)',
        },
      },
      sizeLarge: {
        padding: '12px 24px',
        fontSize: '1rem',
      },
    },
    defaultProps: {
      disableElevation: true,
    },
  },

  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: 16,
        backgroundColor: 'rgba(30, 41, 59, 0.5)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        backgroundImage: 'none',
      },
      elevation1: {
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
      },
      elevation2: {
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
      },
      elevation3: {
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.35)',
      },
    },
  },

  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 16,
        backgroundColor: 'rgba(30, 41, 59, 0.5)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
      },
    },
  },

  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiInputLabel-root': {
          color: '#94A3B8',
          '&.Mui-focused': {
            color: '#12B4A1',
          },
        },
        '& .MuiOutlinedInput-root': {
          borderRadius: 10,
          color: '#F1F5F9',
          backgroundColor: 'rgba(15, 23, 42, 0.5)',
          transition: 'all 0.2s ease-in-out',
          '& fieldset': {
            borderColor: 'rgba(255, 255, 255, 0.1)',
          },
          '&:hover fieldset': {
            borderColor: 'rgba(18, 180, 161, 0.5)',
          },
          '&.Mui-focused fieldset': {
            borderWidth: 2,
            borderColor: '#12B4A1',
          },
          '&.Mui-focused': {
            boxShadow: '0 0 0 3px rgba(18, 180, 161, 0.15)',
          },
        },
        '& .MuiInputBase-input::placeholder': {
          color: '#64748B',
          opacity: 1,
        },
      },
    },
    defaultProps: {
      variant: 'outlined',
    },
  },

  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: 20,
        backgroundColor: '#1E293B',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: '0 24px 64px rgba(0, 0, 0, 0.4)',
      },
    },
  },

  MuiDialogTitle: {
    styleOverrides: {
      root: {
        color: '#F1F5F9',
        fontWeight: 600,
      },
    },
  },

  MuiDialogContent: {
    styleOverrides: {
      root: {
        color: '#E2E8F0',
      },
    },
  },

  MuiDrawer: {
    styleOverrides: {
      paper: {
        backgroundColor: '#0F172A',
        borderRight: '1px solid rgba(255, 255, 255, 0.06)',
        boxShadow: '4px 0px 24px rgba(0, 0, 0, 0.3)',
      },
    },
  },

  MuiTableContainer: {
    styleOverrides: {
      root: {
        borderRadius: 16,
        backgroundColor: 'rgba(30, 41, 59, 0.5)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
      },
    },
  },

  MuiTableHead: {
    styleOverrides: {
      root: {
        '& .MuiTableCell-root': {
          fontWeight: 600,
          fontSize: '0.8rem',
          letterSpacing: '0.05em',
          textTransform: 'uppercase',
          backgroundColor: 'rgba(15, 23, 42, 0.6)',
          color: '#94A3B8',
          borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
          padding: '14px 16px',
        },
      },
    },
  },

  MuiTableCell: {
    styleOverrides: {
      root: {
        padding: '14px 16px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
        color: '#E2E8F0',
        fontSize: '0.875rem',
      },
      head: {
        backgroundColor: 'rgba(15, 23, 42, 0.6)',
        color: '#94A3B8',
      },
    },
  },

  MuiTableRow: {
    styleOverrides: {
      root: {
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          backgroundColor: 'rgba(18, 180, 161, 0.05)',
        },
        '&:nth-of-type(even)': {
          backgroundColor: 'rgba(15, 23, 42, 0.3)',
        },
      },
    },
  },

  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        fontWeight: 600,
        fontSize: '0.75rem',
      },
      filled: {
        backgroundColor: 'rgba(18, 180, 161, 0.15)',
        color: '#12B4A1',
      },
      outlined: {
        borderColor: 'rgba(255, 255, 255, 0.2)',
        color: '#E2E8F0',
      },
    },
  },

  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundColor: '#0F172A',
        borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
        boxShadow: 'none',
      },
    },
  },

  MuiIconButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        color: '#94A3B8',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          backgroundColor: 'rgba(18, 180, 161, 0.1)',
          color: '#12B4A1',
        },
      },
    },
  },

  MuiListItemButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        marginBottom: 4,
        color: 'rgba(255, 255, 255, 0.7)',
        transition: 'all 0.2s ease-in-out',
        '&.Mui-selected': {
          backgroundColor: 'rgba(18, 180, 161, 0.15)',
          borderLeft: '3px solid #12B4A1',
          color: '#F1F5F9',
          '&:hover': {
            backgroundColor: 'rgba(18, 180, 161, 0.2)',
          },
        },
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          color: '#F1F5F9',
        },
      },
    },
  },

  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: '#334155',
        color: '#F1F5F9',
        fontSize: '0.8rem',
        borderRadius: 8,
        padding: '8px 12px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)',
      },
      arrow: {
        color: '#334155',
      },
    },
  },

  MuiBackdrop: {
    styleOverrides: {
      root: {
        backgroundColor: 'rgba(15, 23, 42, 0.6)',
        backdropFilter: 'blur(4px)',
      },
    },
  },

  MuiPagination: {
    styleOverrides: {
      root: {
        padding: '16px',
        display: 'flex',
        justifyContent: 'center',
        '& .MuiPaginationItem-root': {
          borderRadius: 8,
          fontWeight: 500,
          color: '#94A3B8',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          '&:hover': {
            backgroundColor: 'rgba(18, 180, 161, 0.1)',
            borderColor: 'rgba(18, 180, 161, 0.3)',
          },
          '&.Mui-selected': {
            background: 'linear-gradient(135deg, #139979 0%, #12B4A1 50%, #0596B3 100%)',
            color: '#FFFFFF',
            border: 'none',
            '&:hover': {
              background: 'linear-gradient(135deg, #107D63 0%, #0E9185 50%, #047799 100%)',
            },
          },
        },
      },
    },
  },

  MuiLinearProgress: {
    styleOverrides: {
      root: {
        borderRadius: 4,
        height: 6,
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
      },
      bar: {
        borderRadius: 4,
        background: 'linear-gradient(135deg, #139979 0%, #12B4A1 50%, #0596B3 100%)',
      },
    },
  },

  MuiCircularProgress: {
    styleOverrides: {
      root: {
        color: '#12B4A1',
      },
    },
  },

  MuiBadge: {
    styleOverrides: {
      badge: {
        fontWeight: 600,
        fontSize: '0.7rem',
        minWidth: 18,
        height: 18,
        borderRadius: 9,
      },
    },
  },

  MuiSelect: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(255, 255, 255, 0.1)',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(18, 180, 161, 0.5)',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#12B4A1',
        },
      },
      icon: {
        color: '#94A3B8',
      },
    },
  },

  MuiMenu: {
    styleOverrides: {
      paper: {
        backgroundColor: '#1E293B',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
      },
    },
  },

  MuiMenuItem: {
    styleOverrides: {
      root: {
        color: '#E2E8F0',
        '&:hover': {
          backgroundColor: 'rgba(18, 180, 161, 0.1)',
        },
        '&.Mui-selected': {
          backgroundColor: 'rgba(18, 180, 161, 0.15)',
          '&:hover': {
            backgroundColor: 'rgba(18, 180, 161, 0.2)',
          },
        },
      },
    },
  },

  MuiDivider: {
    styleOverrides: {
      root: {
        borderColor: 'rgba(255, 255, 255, 0.06)',
      },
    },
  },

  MuiSkeleton: {
    styleOverrides: {
      root: {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
      },
    },
  },

  MuiAlert: {
    styleOverrides: {
      root: {
        borderRadius: 12,
      },
      standardSuccess: {
        backgroundColor: 'rgba(102, 187, 106, 0.12)',
        color: '#66BB6A',
      },
      standardError: {
        backgroundColor: 'rgba(255, 107, 107, 0.12)',
        color: '#FF6B6B',
      },
      standardWarning: {
        backgroundColor: 'rgba(255, 167, 38, 0.12)',
        color: '#FFA726',
      },
      standardInfo: {
        backgroundColor: 'rgba(33, 150, 243, 0.12)',
        color: '#2196F3',
      },
    },
  },
};

export default components;
